import delay from './delay';

// This file mocks a web API by working with the hard-coded data below.
// It uses setTimeout to simulate the delay of an AJAX call.
// All calls return promises.
const initUser = [
{
"id": 0,
"firstName": '',
"lastName": '',
"userName": '',
"email": '',
"password": '',
"role": '',
"libraries": [],
"students": [],
"classRooms": []
}
];

const users = [
{
"id": 1,
"firstName": 'Cheryl',
"lastName": 'Hines',
"userName": 'cheryl',
"email": 'cheryl@demo.com',
"zipCode": "",
"password": 'cheryl',
"role": 'Educator',
"students": [3,4],
"classRooms": [1]
},
{
"id": 2,
"firstName": 'Scott',
"lastName": 'Allen',
"userName": 'scott',
"email": 'scott@demo.com',
"zipCode": "",
"password": 'scott',
"role": 'Parent',
"children": [3,4]
},
{
"id": 3,
"firstName": 'Kevin',
"lastName": 'Allen',
"userName": 'kevin',
"email": 'kevin@demo.com',
"zipCode": "",
"password": 'kevin',
"role": 'Student',
"parents": [2],
"classRooms": [1]
},
{
"id": 4,
"firstName": 'Tina',
"lastName": 'Allen',
"userName": 'tina',
"email": 'tina@demo.com',
"zipCode": "",
"password": 'tina',
"role": 'Student',
"parents": [2],
"classRooms": [1]
},
{
"id": 5,
"firstName": 'Jessica',
"lastName": 'Wahlin',
"userName": 'jessica',
"email": 'jessica@demo.com',
"zipCode": "",
"password": 'jessica',
"role": 'Parent',
"children": [6]
},
{
"id": 6,
"firstName": 'Chelsea',
"lastName": 'Wahlin',
"userName": 'chelsea',
"email": 'chelsea@demo.com',
"zipCode": "",
"password": 'chelsea',
"role": 'Student',
"parents": [5],
"classRooms": [2]
},
{
"id": 7,
"firstName": 'Edna',
"lastName": 'Alexander',
"userName": 'edna',
"email": 'edna@demo.com',
"zipCode": "",
"password": 'edna',
"role": 'Educator',
"students": [6],
"classRooms": [2]
}
];

//This would be performed on the server in a real app. Just stubbing in.
// const generateId = (user) => {
//   return user.firstName.toLowerCase() + '-' + user.lastName.toLowerCase();
// };

class UserApi {
	static getInitialUser() {
		return new Promise((resolve, reject) => {
		setTimeout(() => {
			resolve(Object.assign([], initUser));
			}, delay);
		});
	}

	static getAllUsers() {
		return new Promise((resolve, reject) => {
		setTimeout(() => {
			resolve(Object.assign([], users));
			}, delay);
		});
	}
}

export default UserApi;



/** WEBPACK FOOTER **
 ** ./src/api/mockUserApi.js
 **/